/** The sprints still open for the client: one a product worked in and has not closed, since its figures can still change. */
export const openForClient = (
  sprintIds: string[],
  products: { closed: string[]; worked: (sprintId: string) => boolean }[],
): string[] => sprintIds.filter(id => products.some(product => product.worked(id) && !product.closed.includes(id)));
